/**
 * defa.models.ZoneSettings
 * The DEFA ZoneSettings model
 * @version 1.2.1
 */
import { defa } from 'defa-object';
import Model    from 'scripts/poppet/model';



const ZoneSettings = Model.extend({
	
	// ------------------------------------------------
	// Setup
	// ------------------------------------------------

	
	defaults : {
		id: null,
		enabled: true,
		zoneAlias: '',
		temperatureAlias: '',
	},
	
	// ------------------------------------------------
	// Event Handlers
	// ------------------------------------------------
	
	// ------------------------------------------------
	// Other functions
	// ------------------------------------------------

	
});

export default ZoneSettings